// @ts-check

/**
 * @file Builds route paths while preserving system-test query parameters.
 */

const CARRIED_SEARCH_PARAMS = [
  "backendHost",
  "backendPort",
  "backendProtocol",
  "performanceDebug",
  "platform",
  "projectId",
  "systemTest",
  "systemTestClientWsPort",
  "systemTestDebug",
  "systemTestProjectSync",
  "systemTestScoundrelPort"
]

/**
 * Build a route path carrying system test search params from the current URL.
 * @param {Record<string, string | string[] | undefined>} params Current route params.
 * @param {string} path Destination path to build.
 * @returns {string} Destination path with carried query params.
 */
export default function buildRoutePath(params, path) {
  const url = new URL(path, "http://placeholder")

  for (const key of CARRIED_SEARCH_PARAMS) {
    const value = params[key]

    if (typeof value === "string" && value) {
      url.searchParams.set(key, value)
    }
  }

  const search = url.searchParams.toString()

  return search ? `${url.pathname}?${search}` : url.pathname
}
